import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";

import useNavigateTo from "../../../hooks/useNavigateTo";

interface BackButtonProps {
  onCancel?: () => void;
}

const CancelButton = (props: BackButtonProps) => {
  const { t } = useTranslation();
  const { onCancel } = props;

  const { navigateBack } = useNavigateTo();

  const clickButton = () => (onCancel ? onCancel() : navigateBack());

  return (
    <Button onClick={clickButton} size="medium">
      {t("cancel")}
    </Button>
  );
};

export default CancelButton;
